/**
 * useDeleteCustomer — the soft-delete-customer mutation (DELETE /customers/:id).
 *
 * Calls the typed client (apiClient.customers.delete) and, on success, invalidates
 * every Kunden-grid query so the deleted firma disappears from the list. The caller
 * owns the confirm dialog, navigation away from the detail, and the success/error toast.
 *
 * Scope: firmen only — the api endpoint soft-deletes a firma (person-subject customers
 * are not deletable in the MVP). The caller only opens the confirm for a firma subject.
 *
 * [Source: apps/web/src/features/customers/hooks/useCreateCustomer.ts] (mutation + invalidate pattern)
 * [Source: architecture/frontend-architecture.md#3-server-state-tanstack-query-v5]
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../../../lib/api-client';

export function useDeleteCustomer() {
  const qc = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: (firmaId: string) => apiClient.customers.delete(firmaId),
    onSuccess: () => {
      // Refresh every Kunden-grid page (all filter/mode variants share the ['customers'] prefix).
      void qc.invalidateQueries({ queryKey: ['customers'] });
    },
  });
}
